/* eslint-disable max-len */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';
import {
  withStyles,
} from '@material-ui/core';

import { rejectionReasons } from '../../../../../../../../config/types';
import noPhoto from '../../../../../../../../images/no-photo.png';
import RejectionIcon from '../../../../../../../../images/rejection-icon.png';
import closeIcon from '../../../../../../../../images/close-icon.png';
import { Modal } from '../../../../../../../../components';
import { trackRejectionImageView } from '../../../../../../../../services/rejectionTracking';
import styles from './styles.js';

class RejectionCell extends Component {
  state = {
    open: false,
  };

  static propTypes = {
    classes: PropTypes.object,
    RejectionReason: PropTypes.number,
    // An array of photo URLs, despite the name - the service returns one entry
    // per picture the inbound team took.
    ImageURL: PropTypes.arrayOf(PropTypes.string),
    // Identifies the rejected line, so a view can be counted against it.
    OrderDetailsID: PropTypes.number,
  };

  static defaultProps = {
    classes: {},
    RejectionReason: 15,
    ImageURL: [],
    OrderDetailsID: null,
  };

  /**
   * Opening the modal is the moment the customer actually sees the photo, so
   * it is the moment worth recording - not rendering the row, which happens
   * whether or not they are interested.
   */
  handleOpen = () => {
    const { OrderDetailsID, RejectionReason, ImageURL } = this.props;

    this.setState({ open: true });

    trackRejectionImageView({
      orderDetailsId: OrderDetailsID,
      rejectionReason: RejectionReason,
      imageCount: (ImageURL || []).length,
    });
  }

  renderRejectModal = () => {
    const { classes, RejectionReason, ImageURL } = this.props;
    const { open } = this.state;
    const avoidText = 'How do I avoid this problem in the future?'.toUpperCase();
    const pictureText = 'Picture of your item'.toUpperCase();
    const avoidDescription = 'Please check all books are not damaged and meet our minimum standard before sending.';
    return (
      <Modal handleClose={this.handleClose} open={open}>
        <div className={classes.modalContainer}>
          <div className={classes.modalTopContainer}>
            <span>DAMAGED</span>
            <div
              role={'button'}
              tabIndex={0}
              onKeyPress={this.handleClose}
              className={classes.modalCloseIconContainer}
              onClick={this.handleClose}
            >
              <img className={classes.modalCloseIcon} src={closeIcon} alt={'close icon'} />
            </div>
          </div>
          <div className={classes.modalContent}>
            <div className={classes.modalImageContainer}>
              <div className={classes.imageContainer}>
                {(ImageURL || []).map((image) => {
                  return (
                    <img
                      key={image || uuidv4()}
                      className={classes.modalImage}
                      src={image || noPhoto}
                      alt={'book'}
                    />);
                })}
              </div>
              <span className={classes.miniRegularText}>{pictureText}</span>
            </div>
            <div className={classes.infoContainer}>
              <div className={classes.textContainer}>
                <span className={classes.boldFont}>PROBLEM</span>
                <span>{rejectionReasons[RejectionReason] || 'Damaged'}</span>
              </div>
              <div className={classes.textContainer}>
                <span className={classes.boldFont}>{avoidText}</span>
                <span>{avoidDescription}</span>
              </div>
            </div>
          </div>
        </div>
      </Modal>);
  }

  handleClose = () => {
    this.setState({ open: false });
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <div
          className={classes.rejectionContainer}
          role={'button'}
          tabIndex={0}
          onKeyPress={this.handleOpen}
          onClick={this.handleOpen}
        >
          <img className={classes.rejectionIcon} src={RejectionIcon} alt={'reject'} />
          <span className={classes.rejectText}>Book damaged</span>
        </div>
        {this.renderRejectModal()}
      </div>
    );
  }
}

export default withStyles(styles)(RejectionCell);
